export function hasCompanyCustomizationAccess(
    customizations: Record<string, unknown>,
    key: 'automatedInsights' | 'core',
): boolean {
    const config = customizations[key] as { enabled?: boolean } | undefined;
    return config?.enabled === true || !(key in customizations);
}
